import React from 'react'

const SvgTicket = props => (
  <svg width="1em" height="1em" viewBox="0 0 99 99" fill="none" {...props}>
    <circle
      cx={49.5}
      cy={49.5}
      r={49.5}
      fill="url(#Ticket_svg__paint0_linear)"
    />
    <path
      d="M80.834 37.007L62.993 19.166c-1.554-1.555-4.103-1.555-5.72 0L48.82 27.62l.56.56c.497.497.497 1.305 0 1.74l-.871.87c-.497.498-1.306.498-1.74 0l-.56-.559-27.042 27.042c-1.555 1.555-1.555 4.103 0 5.72l17.841 17.841c1.554 1.554 4.103 1.554 5.72 0l27.042-27.042-.746-.746c-.498-.497-.498-1.305 0-1.74l.87-.87c.498-.498 1.306-.498 1.74 0l.747.745 8.454-8.454c1.554-1.555 1.554-4.103 0-5.72zm-6.403 4.165l-6.03 6.03-2.362-2.362c-.498-.497-1.306-.497-1.74 0l-.871.87c-.497.498-.497 1.306 0 1.741l2.362 2.362-24.618 24.68c-.746.746-1.865.746-2.61 0L25.506 61.44c-.746-.746-.746-1.865 0-2.611L50.124 34.21l2.176 2.176c.498.497 1.306.497 1.74 0l.871-.87c.497-.498.497-1.306 0-1.741l-2.176-2.176 6.03-6.03c.746-.746 1.865-.746 2.611 0L74.37 38.56c.808.746.808 1.865.062 2.611zm-15.23-3.17c-.498-.497-1.306-.497-1.741 0l-.87.87c-.498.498-.498 1.306 0 1.74l2.61 2.612c.498.497 1.306.497 1.741 0l.87-.87c.498-.498.498-1.306 0-1.741l-2.61-2.611z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="Ticket_svg__paint0_linear"
        x1={32.063}
        y1={-7.313}
        x2={85.14}
        y2={84.15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#288542" />
        <stop offset={1} stopColor="#D9CF7C" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgTicket
